app.config(function ($translateProvider) {
    $translateProvider.translations('en-gb', {
        COMPLIANCE_DOCUMENTS: 'Compliance Documents',
        COMPLIANCE_DOCUMENTS_HEADER: 'Compliance Documents from Vantify Risk Manager',
        COMPLIANCE_DOCUMENTS_AT_CREATION: 'Initial Compliance Documents available:',
        COMPLIANCE_DOCUMENTS_ADDITIONAL_LIVE: 'Additional live Compliance Documents:',

        COMPLIANCE_DOCUMENTS_ARE_NOT_FETCHED: 'Compliance Documents are not fetched yet.',
        COMPLIANCE_DOCUMENTS_NOT_FOUND: 'No Compliance Documents found',
        COMPLIANCE_DOCUMENTS_NO_ADDITIONAL_LIVE_FILES_FOUND: 'No additional live files found',
        COMPLIANCE_DOCUMENTS_NO_SITE_WITH_MATCHING_REFERENCE_FOUND: 'No site with matching reference found',
        COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION: 'Unable to establish Risk Manager Connection - Error Code [{{code}}]',
        COMPLIANCE_DOCUMENTS_UNABLE_TO_ESTABLISH_CONNECTION_NO_CODE: 'Unable to establish Risk Manager Connection'
    });
});
